// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2253":"862337a6","7220":"7ffe7720"}[chunkId] + ".chunk.css";
};